import { render } from "./BithdayCake.vue?vue&type=template&id=1f27227b"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/BithdayCake.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f27227b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f27227b', __exports__)) {
    api.reload('1f27227b', __exports__)
  }
  
  module.hot.accept("./BithdayCake.vue?vue&type=template&id=1f27227b", () => {
    api.rerender('1f27227b', render)
  })

}


export default __exports__